import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { NormalInput, PassWordInput } from "../Common/Input";
import { signupDoctorApi } from "../../api/api";
import CustomSpinner from "../Common/CustomSpinner";

export default function Signup() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  //
  const navigate = useNavigate();

  const [error, setError] = useState({ text: "", error: false });
  const [loading, setLoading] = useState(false);
  const [eye, setEye] = useState(false);

  const redirectUrl = "/assessment-history";

  const onSubmit = async (data) => {
    setLoading(true);
    setError({ text: "", error: false });
    const doctorCode =
      data.first_name[0] +
      data.last_name[0] +
      data.npi_number[0] +
      Math.floor(Math.random() * 9000 + 100);
    const bodyData = {
      email: data.email,
      password: data.password,
      name: data.first_name + " " + data.last_name,
      npi: data.npi_number,
      doctorCode: doctorCode?.toLowerCase(),
    };
    const res = await signupDoctorApi(bodyData);
    if (res) {
      localStorage.setItem("token", res);
      window.location.href = redirectUrl;
    }
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  return (
    <div style={{ width: "50%" }} className="mx-auto">
      <div className=" md:grid gap-7 spac-y-4">
        <div>
          <div className="py-7">
            <h2 className="text-[36px] font-semibold">
              Let's Create Your Account
            </h2>
            <p className="text-[18px] font-[500]">
              We are Happy to see you again. let's get started
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex w-full justify-between items-center">
              <NormalInput
                name={"first_name"}
                placeholder="Type Your First Name"
                required={true}
                styles="py-4 appearance-none block"
                register={register}
                validationSchema={{
                  required: "First Name is required",
                }}
                errors={errors}
                divStyles="w-[49%]"
              />
              <NormalInput
                name={"last_name"}
                placeholder="Type Your Last Name"
                required={true}
                styles="py-4 appearance-none block mr-2"
                register={register}
                validationSchema={{
                  required: "Last Name is required",
                }}
                errors={errors}
                divStyles="w-[49%]"
              />
            </div>
            <div className="mb-6">
              <NormalInput
                type="email"
                name={"email"}
                placeholder="Type Your Email"
                required={true}
                styles="py-4 appearance-none block input_w_full"
                register={register}
                validationSchema={{
                  required: "Email is required",
                }}
                errors={errors}
              />
            </div>
            <div className="mb-6">
              <NormalInput
                type="text"
                name={"npi_number"}
                placeholder="Type Your NPI Number"
                required={true}
                styles="py-4 appearance-none block input_w_full"
                register={register}
                validationSchema={{
                  required: "Email is required",
                }}
                errors={errors}
              />
            </div>

            <div className="mb-4">
              <PassWordInput
                name={"password"}
                placeholder="Type Your Password"
                type="password"
                required={true}
                styles="py-4 appearance-none block input_w_full"
                register={register}
                validationSchema={{
                  required: "Password is required",
                  minLength: {
                    value: 6,
                    message: "Password must have at least 6 characters",
                  },
                }}
                eye={eye}
                setEye={() => setEye(!eye)}
                errors={errors}
              />
            </div>

            <div className="mb-[12px]">
              <p className="text-red-500 text-[18px]">
                {error.error && error.text}
              </p>
            </div>
            <div className="flex flex-col justify-center items-center">
              <button
                className="py-3 w-full bg-[#3c7fff] hover:bg-indigo-800 font-bold px- rounded text-white flex justify-center"
                type="submit"
                disabled={loading}
              >
                {loading ? <CustomSpinner /> : "Create Account"}
              </button>
            </div>
          </form>
          <div className="mt-3 text-center">
            <p>
              Already have an account?{" "}
              <span
                className="text-[#3c7fff] underline underline-offset-1 cursor-pointer"
                onClick={() => navigate("/login")}
              >
                Log in
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
